import {
   Button,
   Dialog,
   DialogActions,
   DialogContent,
   DialogContentText,
   DialogTitle,
   IconButton,
   TextField,
   Typography
} from "@mui/material";
import React from "react";
import { useState } from "react";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./defineSlice";

export default function DisplayComments(params) {
   let comments = params.comments;
   if (comments === undefined || comments === null) {
      comments = "";
   }
   const [displayComments, setDisplayComments] = useState(comments);
   const [userComments, setUserComments] = useState("");
   const [open, setOpen] = useState(false);
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const { gridData, gridDataFiltered } = define;

   const customerID = params.row.customerID;
   const customerGroupID = params.row.customerGroupID;
   const productGroupID = params.row.productGroupID;
   const skuid = params.row.skuid;
   // let color =
   //     comments.length > 0 && comments != "Default Customer quota record"
   //         ? "blue"
   //         : "black";
   // const theme = useTheme();
   // const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
   const handleConfirm = () => {
      setDisplayComments(userComments);
      // color =
      //     userComments.length > 0 &&
      //         userComments != "Default Customer quota record"
      //         ? "blue"
      //         : "black";
      const updated = gridDataFiltered.map((item, index) => {
         const flag =
            item.customerID === customerID &&
            item.customerGroupID === customerGroupID &&
            item.productGroupID === productGroupID &&
            item.skuid === skuid;
         if (flag === true) {
            return {
               ...item,
               customerQuotaComments: !userComments ? 0 : userComments,
            };
         }
         return item;
      });

      const updatedGrid = [];
      for (let i = 0; i < gridData.length; ++i) {
         let item = updated.find(
            (obj) =>
               obj.customerID === gridData[i].customerID &&
               obj.customerGroupID === gridData[i].customerGroupID &&
               obj.productGroupID === gridData[i].productGroupID &&
               obj.skuid === gridData[i].skuid
         );
         if (item) {
            updatedGrid.push(item);
         } else {
            updatedGrid.push(gridData[i]);
         }
      }
      dispatch(setState("gridDataFiltered", updated));
      dispatch(setState("gridData", updatedGrid));
      dispatch(setState("gridDataChanged", true));
      setOpen(false);
   };

   const handleClose = () => {
      setOpen(false);
   };
   return (
      <>
         <IconButton onClick={() => setOpen(true)} title={params.row.customerQuotaComments ? params.row.customerQuotaComments : ''}>
            {params.row.customerQuotaComments ? (
               <ForumOutlinedIcon
                  sx={{ color: "darkBlue.light" }}
                  title={params.row.customerQuotaComments ? params.row.customerQuotaComments : ''}
               />
            ) : (
               <ForumOutlinedIcon />
            )}
         </IconButton>

         <Dialog maxWidth="xs" fullWidth open={open} onClose={handleClose}>
            <DialogTitle id="responsive-dialog-title"> 
            <Typography sx={{color: "darkBlue.light", fontWeight : "700", fontSize : "18px !important"}}>
                  Comments 
                  </Typography></DialogTitle>
            <DialogContent>
               <DialogContentText>
                  <TextField
                     onChange={(event) => setUserComments(event.target.value)}
                     multiline
                     rows={6}
                     className={'fullWidth'}
                     size="large"
                     defaultValue={params.row.customerQuotaComments ? params.row.customerQuotaComments : ''}
                     fullWidth
                     autoFocus={true}
                  />
               </DialogContentText>
            </DialogContent>
            <DialogActions>
               <Button
                  sx={{
                     my: 0.5,
                     bgcolor: "grey.lighter",
                     color: "darkBlue.light",
                     // height: "40px",
                     // fontSize: "14px",
                     boxShadow: "none",
                     "&:hover": {
                        bgcolor: "darkBlue.main",
                        color: "white.main",
                        border: "none",
                     },
                  }}
                  onClick={handleClose}>
                  Cancel
               </Button>
               <Button autoFocus variant="contained"
                  sx={{
                     bgcolor: "darkBlue.light",
                     color: "white.main",
                     fontWeight: "700",
                     textTransform: "none",
                     "&:hover": {
                        bgcolor: "darkBlue.main",

                     },
                  }}
                  onClick={handleConfirm}>
                  Save Changes
               </Button>
            </DialogActions>
         </Dialog>
      </>
   );
}
